// Hard-centre badge images on mobile, but ONLY on product pages
document.addEventListener('DOMContentLoaded', function () {
  // Only run on small/mobile screens
  if (window.innerWidth > 749) return;

  // Only run on product pages (URLs like /products/...)
  if (!window.location.pathname.includes('/products/')) return;

  // Select all badge images by alt text ending in "Badge"
  var badgeImages = document.querySelectorAll('main img[alt$="Badge"]');

  badgeImages.forEach(function (img) {
    // Reset any previous manual offsets
    img.style.position = 'relative';
    img.style.left = '0px';
    img.style.marginLeft = 'auto';
    img.style.marginRight = 'auto';
    img.style.display = 'block';

    // Measure its current position
    var rect = img.getBoundingClientRect();
    var viewportWidth = window.innerWidth;

    // Calculate how far we need to move it horizontally to centre it
    var offset = (viewportWidth - rect.width) / 2 - rect.left;

    // Apply the shift
    img.style.left = offset + 'px';
  });
});